var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3"},[_c('label',[_vm._v("Start With")]),_c('div',{staticClass:"border"},[_c('div',{staticClass:"row p-3"},[_c('div',{staticClass:"col-sm-12 col-md-3 col-lg-3"},[_c('router-link',{attrs:{"to":{
            name: 'AdminPointPrograms',
          }}},[_vm._v("Programs & Contests")])],1),_c('div',{staticClass:"col-sm-12 col-md-3 col-lg-3"},[_c('router-link',{attrs:{"to":{
            name: 'AdminPointProgramsEditClients',
          }}},[_vm._v("Locations or companies")])],1),_c('div',{staticClass:"col-sm-12 col-md-3 col-lg-3"},[_c('router-link',{attrs:{"to":{
            name: 'AdminPointProgramsNewProgramContest',
          }}},[_vm._v("New Program/Contest")])],1),_c('div',{staticClass:"col-sm-12 col-md-3 col-lg-3"},[_c('router-link',{attrs:{"to":{
            name: 'AdminAddPoints',
          }}},[_vm._v("Add Points")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }